import gql from 'graphql-tag'

export default gql`
    query GenerateVZFID {
        generateVZFID
    }
`
